export default __webpack_public_path__ + "static/media/warning.1acf6d9d.svg";